import { Component, Input, OnInit } from '@angular/core';
import { ApplicationPathConstants } from '@ddt-web/config';
import { UrlService } from '@ddt-web/url';
import { Observable, of } from 'rxjs';
import { first } from 'rxjs/operators';

import { ModelsBrowseDataService } from '../services/models-browse-data.service';

@Component({
	selector: 'mb-family-footer',
	templateUrl: './family-footer.component.html',
	styleUrls: ['./family-footer.component.scss']
})
export class FamilyFooterComponent implements OnInit {
	@Input() public familyId: string;
	@Input() public showFundPerformanceLink: boolean = true;

	public groupId: string;
	public modelIds: Observable<Array<string>>;
	public appPaths = ApplicationPathConstants.MODELS_BROWSE_PATHS;

	constructor(
		private urlService: UrlService,
		private modelsBrowseDataService: ModelsBrowseDataService
	) { }

	public ngOnInit(): void {
		this.familyId = this.familyId || this.urlService.getModelFamilyId();
		this.groupId = this.urlService.getModelGroupId();
		if (this.familyId) {
			this.modelsBrowseDataService.fetchFamilyHoldings(this.familyId, true)
				.pipe(first())
				.subscribe(holdings => {
					// Set Model Ids for preparing component data for holdings table body
					this.modelIds = of(holdings.map(model => model.id));
				});
		}

	}

}
